import moment from 'moment';
import get from 'lodash.get';

// Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
// HACK: disobeys folder structure rules
import {
    selectFirstDate,
    selectNumberOfDays
    // @ts-ignore
} from 'components/DatePagination/selectors';
import { selectMyTimesheetEntriesDateTotals } from 'services/myTimesheetEntries/selectors';

// Global Utils
import minutesToDuration from 'utils/minutes-to-duration';

const selectMyTimesheetEntriesWeekTotal = createDeepEqualSelector(
    [selectFirstDate, selectNumberOfDays, selectMyTimesheetEntriesDateTotals],
    (
        firstDateState: string,
        numberOfDays: number,
        myTimesheetEntriesDateTotalsState
    ): string => {
        let totalMinutes = 0;

        for (let i = 0; i < numberOfDays; i++) {
            const date = moment(firstDateState, 'YYYY-MM-DD')
                .add(i, 'days')
                .format('YYYY-MM-DD');
            totalMinutes += get(myTimesheetEntriesDateTotalsState, date, 0);
        }

        return minutesToDuration(totalMinutes);
    }
);

const makeSelectMyTimesheetEntriesWeekTotal = (): typeof selectMyTimesheetEntriesWeekTotal =>
    selectMyTimesheetEntriesWeekTotal;

export {
    selectMyTimesheetEntriesWeekTotal,
    makeSelectMyTimesheetEntriesWeekTotal
};
